import { gql } from '@apollo/client';

export const fetchParentEntitlementDetails = gql`
  query fetchParentEntitlementDetails($id: String!) {
    entitlementDetails(id: $id) {
      id
      transactionAccountId
      parentEntitlementDetails {
        entitlementId
        productId
        entitlementNumber
        productName
        latestPeriodEndDate
        offeringId
        subscriptionId
        billingStatus
        isApp
        relatesToEntitlements {
          relationshipType
          entitlementId
          relationshipId
        }
        scheduledChanges {
          subscriptionScheduleAction
        }
      }
    }
  }
`;
